var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuaSidebarPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 408,
    height: 200,
    viewBox: "0 0 408 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "bg-a",
    width: 408,
    height: 200
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bg-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bg-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#A54DE1",
    xlinkHref: "#bg-a"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    fillOpacity: 0.08,
    points: "0 0 408 0 408 68.318 78.491 200 0 200",
    mask: "url(#bg-b)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    fillOpacity: 0.24,
    points: "258 0 408 0 290.712 200 258 200",
    mask: "url(#bg-b)",
    transform: "rotate(180 333 100)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    fillOpacity: 0.16,
    points: "0 122 408 122 0 199",
    mask: "url(#bg-b)",
    transform: "matrix(1 0 0 -1 0 321)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuaSidebarPlaceholder);
export default __webpack_public_path__ + "static/media/bua-sidebar-placeholder.4330b884d167f7a9ba9a08119a1c3fa9.svg";
export { ForwardRef as ReactComponent };